<template>
  <div id="coin_seller_ranking">
    <van-row>
      <van-col span="24">
        <van-col span="24">
          <van-nav-bar
              left-arrow
              placeholder
              safe-area-inset-top
              @click-left="onClickLeft"
              :title="$t('title.coin_seller_ranking')"
          />
        </van-col>
        <van-col span="22" offset="1" class="coin_seller_ranking_day">
          <van-tabs type="card" v-model="day_active" @click="onClickRankingDay">
            <van-tab :title="$t('column.day_list')" name="day"></van-tab>
            <van-tab :title="$t('column.week_list')" name="week"></van-tab>
            <van-tab :title="$t('column.Monthly_list')" name="month"></van-tab>
          </van-tabs>
        </van-col>
        <van-col span="22" offset="1" class="coin_seller_ranking_number_title_bg">
          <van-col span="7" class="coin_seller_ranking_number">
            <van-col span="22" offset="1" class="coin_seller_ranking_number_bg coin_seller_ranking_number_bg2" @click="JumpUserinfo(list.length > 1 ? list[1].user_id : 0)">
              <img src="../assets/img/rank/rank2.png" class="coin_seller_ranking_number_img2"/>
              <van-image
                  width="12vw"
                  height="12vw"
                  round
                  class="coin_seller_ranking_number_avatar"
                  fit="cover"
                  :src="list[1].head_image"
                  v-if="list.length > 1"
              />
              <van-col span="22" offset="1" class="coin_seller_ranking_number_name"> {{ list.length > 1 ? list[1].nick_name : '' }}</van-col>
              <van-col span="22" offset="1" class="coin_seller_ranking_number_coin">{{ list.length > 1 ? list[1].deduct_coin_sum : '' }} <img src="../assets/img/coin10.png"/> </van-col>
            </van-col>
          </van-col>
          <van-col span="10" class="coin_seller_ranking_number">
            <van-col span="20" offset="2" class="coin_seller_ranking_number_bg" @click="JumpUserinfo(list.length > 0 ? list[0].user_id : 0)">
              <img src="../assets/img/rank/rank1.png" class="coin_seller_ranking_number_img"/>
              <van-image
                  width="12vw"
                  height="12vw"
                  round
                  class="coin_seller_ranking_number_avatar"
                  fit="cover"
                  :src="list[0].head_image"
                  v-if="list.length > 0"
              />
              <van-col span="22" offset="1" class="coin_seller_ranking_number_name">{{ list.length > 0 ? list[0].nick_name : '' }} </van-col>
              <van-col span="22" offset="1" class="coin_seller_ranking_number_coin"> {{ list.length > 0 ? list[0].deduct_coin_sum : '' }} <img src="../assets/img/coin10.png"/>  </van-col>
            </van-col>
          </van-col>
          <van-col span="7" class="coin_seller_ranking_number">
            <van-col span="22" offset="1" class="coin_seller_ranking_number_bg coin_seller_ranking_number_bg2" @click="JumpUserinfo(list.length > 2 ? list[2].user_id : 0)">
              <img src="../assets/img/rank/rank3.png" class="coin_seller_ranking_number_img2"/>
              <van-image
                  width="12vw"
                  height="12vw"
                  round
                  class="coin_seller_ranking_number_avatar"
                  fit="cover"
                  :src="list[2].head_image"
                  v-if="list.length > 2"
              />
              <van-col span="22" offset="1" class="coin_seller_ranking_number_name">{{ list.length > 2 ? list[2].nick_name : '' }} </van-col>
              <van-col span="22" offset="1" class="coin_seller_ranking_number_coin">  {{ list.length > 2 ? list[2].deduct_coin_sum : '' }} <img src="../assets/img/coin10.png"/>   </van-col>
            </van-col>
          </van-col>
        </van-col>
      </van-col>
      <van-col span="22" offset="1" class="coin_seller_ranking_list">
        <van-list >
          <van-cell v-for="(item,i) in list" :key="i" v-if="i > 2">
            <van-col span="24" class="coin_seller_ranking_list_item">
              <van-col span="3" class="coin_seller_ranking_list_number">{{ i + 1 }}</van-col>
              <van-col span="4" class="coin_seller_ranking_list_item_avatar">
                <van-image
                    width="13vw"
                    height="13vw"
                    round
                    :src="item.head_image"
                    fit="cover"
                    @click="JumpUserinfo(item.user_id)"
                />
               </van-col>
              <van-col span="8" class="coin_seller_ranking_list_item_name"> {{ item.nick_name }} </van-col>
              <van-col span="8" class="coin_seller_ranking_list_item_coin">{{ $t('column.sold_for_coin',{number: item.deduct_coin_sum }) }} <img src="../assets/img/coin10.png"/></van-col>
            </van-col>
          </van-cell>
        </van-list>
      </van-col>
      <van-overlay :show="overlayShow" z-index="3">
        <van-loading type="spinner" class="loading_overlay"/>
      </van-overlay>
    </van-row>
  </div>
</template>

<script>

import '@/assets/css/style.css'
import axios from "axios";
import {Toast} from "vant";
export default {
  data() {
    return {
      day_active: 'day',
      list: [],
      overlayShow: false,
      finished: false
    }
  },
  created() {
    this.convert()
  },
  methods: {
    onClickRankingDay(name, title) {
      this.day_active = name
      this.convert()
    },
    onClickLeft() {
      this.$router.go(-1)
    },
    JumpUserinfo(id) {
      console.log(id)
      if(id){
        // 拦截跳转用户主页面
        window.location.href="live://live?action=JumpUser&id=" + id
      }
    },
    convert() {
      this.overlayShow = true
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=coin_seller&act=get_coin_seller_rank_list", {
        params : {
          token: token,
          type: this.day_active,
        }
      }).then(res =>{
        this.overlayShow = false
        if (res.data.status === 0) {
          Toast(res.data.error)
          return false
        }
        this.list = []
        for(let i = 0; i< res.data.data.list.length; i ++) {
          this.list.push(res.data.data.list[i])
        }
        this.finished = true
      })
    }
  }
}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/coin_seller_ranking.vue